import { render } from "./GenerarEtiquetas.vue?vue&type=template&id=52c8f8c6&scoped=true"
import script from "./GenerarEtiquetas.vue?vue&type=script&lang=js"
export * from "./GenerarEtiquetas.vue?vue&type=script&lang=js"

import "./GenerarEtiquetas.vue?vue&type=style&index=0&id=52c8f8c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c8f8c6"]])

export default __exports__